const validateEmail = email => {
  const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(String(email).toLowerCase());
};

const validateCreditCard = (card, cardtype) => {
  const cardNumber = card.replace(/\D/g, '');
  let minDigits = 16;
  if (cardtype === 'American Express') {
    minDigits = 15;
  }
  if (cardNumber.length < minDigits) return false;
  return true;
};

const validateCVV = (cvv, cardtype) => {
  const cvvNumber = cvv.replace(/\D/g, '');
  let minDigits = 3;
  if (cardtype === 'American Express') {
    minDigits = 4;
  }
  if (cvvNumber.length < minDigits) return false;
  return true;
};

export const getFormErrors = e => {
  const errors = [];
  const formElements = Array.from(e.target.elements).filter(
    item =>
      item.tagName === 'INPUT' || item.tagName === 'SELECT' || item.tagName === 'TEXTAREA'
  );
  formElements.forEach(element => {
    element.value = element.value.trim();
    if (element.type === 'email') {
      if (!validateEmail(element.value)) {
        errors.push(element.name);
      }
    } else if (element.name === 'card_number') {
      const { cardtype } = element.dataset;
      if (!validateCreditCard(element.value, cardtype)) errors.push(element.name);
    } else if (element.name === 'cvv_code') {
      const { cardtype } = element.dataset;
      if (!validateCVV(element.value, cardtype)) errors.push(element.name);
    } else if (!element.checkValidity()) {
      errors.push(element.name);
    }
  });
  return errors;
};

export const isValidField = (errors, name) => {
  if (errors && errors.find(e => e === name)) {
    return 'is-invalid';
  }
  return '';
};
